import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Donationdetails = () => {
  const navigate = useNavigate();

  const [selectedAmount, setSelectedAmount] = useState(10);
  const [customAmount, setCustomAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('one-time');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Campaign Details</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li><Link to="/donations">Support Pathio</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Campaign Details</li>
          </ul>
        </div>
      </section>

      <div className="ul-container ul-section-spacing">
        <div className="row gx-0 gy-4 flex-column-reverse flex-lg-row">

          <div className="col-lg-4">
            <div className="ul-inner-sidebar">

              <div className="ul-inner-sidebar-widget categories">
                <h3 className="ul-inner-sidebar-widget-title">Campaign Types</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <div className="ul-inner-sidebar-categories">
                    <Link to="/donations"
                      >Health Literacy Education <span>(4)</span></Link
                    >
                    <Link to="/donations"
                      >Resource Directories <span>(2)</span></Link
                    >
                    <Link to="/donations"
                      >Mentorship Programs <span>(1)</span></Link
                    >
                    <Link to="/donations"
                      >Community Workshops <span>(1)</span></Link
                    >
                  </div>
                </div>
              </div>

              <div className="ul-inner-sidebar-widget posts">
                <h3 className="ul-inner-sidebar-widget-title">Recent Campaigns</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <div className="ul-inner-sidebar-posts">

                    <div className="ul-inner-sidebar-post">
                      <div className="img">
                        <img
                          src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg"
                          alt="Campaign Image"
                        />
                      </div>

                      <div className="txt">
                        <h4 className="title">
                          <Link to="/donation-details"
                            >Diabetes Education for Uzbek & Central Asian
                            Families</Link
                          >
                        </h4>
                        <span className="date"> <span>Active Campaign</span></span>
                      </div>
                    </div>

                    <div className="ul-inner-sidebar-post">
                      <div className="img">
                        <img
                          src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg"
                          alt="Campaign Image"
                        />
                      </div>

                      <div className="txt">
                        <h4 className="title">
                          <Link to="/donation-details"
                            >Hypertension Management Guide</Link
                          >
                        </h4>
                        <span className="date"> <span>Active Campaign</span></span>
                      </div>
                    </div>

                    <div className="ul-inner-sidebar-post">
                      <div className="img">
                        <img
                          src="/assets/new-img/high-school-students-raising-hands-in-classroom-du-2025-03-05-05-09-38-utc.jpg"
                          alt="Campaign Image"
                        />
                      </div>

                      <div className="txt">
                        <h4 className="title">
                          <Link to="/donation-details"
                            >NYC Clinic Directory</Link
                          >
                        </h4>
                        <span className="date"> <span>Active Campaign</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ul-inner-sidebar-widget tags">
                <h3 className="ul-inner-sidebar-widget-title">Health Topics</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <div className="ul-inner-sidebar-tags">
                    <Link to="/donations">Diabetes</Link>
                    <Link to="/donations">Hypertension</Link>
                    <Link to="/donations">Mental Health</Link>
                    <Link to="/donations">Asthma</Link>
                    <Link to="/donations">Uzbek</Link>
                    <Link to="/donations">Russian</Link>
                    <Link to="/donations">Tajik</Link>
                    <Link to="/donations">NYC</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="ul-donation-details">
              <div className="ul-donation-details-img">
                <img
                  src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg"
                  alt="Campaign Image"
                />
              </div>
              <h2 className="ul-donation-details-raised">
                2,100 <span className="target">of 3,000 people reached</span>
              </h2>
              <div className="ul-donation-progress ul-donation-progress-2">
                <div className="donation-progress-container ul-progress-container">
                  <div
                    className="donation-progressbar ul-progressbar"
                    data-ul-progress-value="70"
                  >
                    <div
                      className="donation-progress-label ul-progress-label"
                    ></div>
                  </div>
                </div>
              </div>
              <h1 className="ul-donation-details-title">
                Diabetes Education for Uzbek & Central Asian Families
              </h1>
              <p className="ul-donation-details-subtitle">
                Bilingual health literacy campaign connecting NYC families to
                verified healthcare resources
              </p>

              <div className="ul-donation-details-notice">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0003 20.6667C14.3781 20.6667 14.695 20.5387 14.951 20.2827C15.207 20.0267 15.3345 19.7103 15.3337 19.3334C15.3328 18.9565 15.2048 18.6401 14.9497 18.3841C14.6945 18.1281 14.3781 18.0001 14.0003 18.0001C13.6225 18.0001 13.3061 18.1281 13.051 18.3841C12.7959 18.6401 12.6679 18.9565 12.667 19.3334C12.6661 19.7103 12.7941 20.0272 13.051 20.2841C13.3079 20.541 13.6243 20.6685 14.0003 20.6667ZM14.0003 15.3334C14.3781 15.3334 14.695 15.2054 14.951 14.9494C15.207 14.6934 15.3345 14.377 15.3337 14.0001V8.66675C15.3337 8.28897 15.2057 7.97253 14.9497 7.71741C14.6937 7.4623 14.3772 7.3343 14.0003 7.33341C13.6234 7.33253 13.307 7.46053 13.051 7.71741C12.795 7.9743 12.667 8.29075 12.667 8.66675V14.0001C12.667 14.3779 12.795 14.6947 13.051 14.9507C13.307 15.2067 13.6234 15.3343 14.0003 15.3334ZM14.0003 27.3334C12.1559 27.3334 10.4226 26.9832 8.80033 26.2827C7.17811 25.5823 5.76699 24.6325 4.56699 23.4334C3.36699 22.2343 2.41722 20.8232 1.71766 19.2001C1.01811 17.577 0.667883 15.8436 0.666994 14.0001C0.666105 12.1565 1.01633 10.4232 1.71766 8.80008C2.41899 7.17697 3.36877 5.76586 4.56699 4.56675C5.76522 3.36764 7.17633 2.41786 8.80033 1.71741C10.4243 1.01697 12.1577 0.666748 14.0003 0.666748C15.843 0.666748 17.5763 1.01697 19.2003 1.71741C20.8243 2.41786 22.2354 3.36764 23.4337 4.56675C24.6319 5.76586 25.5821 7.17697 26.2843 8.80008C26.9865 10.4232 27.3363 12.1565 27.3337 14.0001C27.331 15.8436 26.9808 17.577 26.283 19.2001C25.5852 20.8232 24.6354 22.2343 23.4337 23.4334C22.2319 24.6325 20.8208 25.5827 19.2003 26.2841C17.5799 26.9854 15.8465 27.3352 14.0003 27.3334Z"
                    fill="var(--ul-primary)"
                  />
                </svg>
                <p>
                  <strong>Support Pathio</strong>: Your contribution helps us
                  create science-based health literacy content for Uzbek,
                  Russian, and Tajik-speaking communities in NYC.
                </p>
              </div>

              <form action="#" className="ul-donation-details-form" onSubmit={(e) => {
                e.preventDefault();
                const campaignTitle = 'Diabetes Education for Uzbek & Central Asian Families';
                const prefill = {
                  amount: selectedAmount,
                  frequency: paymentMethod,
                  donorName: `${firstName} ${lastName}`.trim(),
                  donorEmail: email,
                  purpose: 'education',
                  campaignTitle
                };
                try {
                  sessionStorage.setItem('prefillDonation', JSON.stringify(prefill));
                } catch (err) {
                  console.warn('Could not save prefill', err);
                }
                navigate('/donate');
              }}>

                <div className="ul-donation-details-donate-form-wrapper">
                  <div className="selected-amount">
                    <span className="currency">$</span>
                    <span className="number">{(selectedAmount || 0).toFixed(2)}</span>
                  </div>
                  <div className="ul-donate-form">
                    <div>
                      <input
                        type="radio"
                        name="donate-amount"
                        id="donate-amount-1"
                        checked={selectedAmount === 10}
                        onChange={() => { setSelectedAmount(10); setCustomAmount(''); }}
                        hidden
                      />
                      <label htmlFor="donate-amount-1" className="ul-donate-form-label">$10</label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        name="donate-amount"
                        id="donate-amount-2"
                        checked={selectedAmount === 20}
                        onChange={() => { setSelectedAmount(20); setCustomAmount(''); }}
                        hidden
                      />
                      <label htmlFor="donate-amount-2" className="ul-donate-form-label">$20</label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        name="donate-amount"
                        id="donate-amount-3"
                        checked={selectedAmount === 30}
                        onChange={() => { setSelectedAmount(30); setCustomAmount(''); }}
                        hidden
                      />
                      <label htmlFor="donate-amount-3" className="ul-donate-form-label">$30</label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        name="donate-amount"
                        id="donate-amount-4"
                        checked={selectedAmount === 40}
                        onChange={() => { setSelectedAmount(40); setCustomAmount(''); }}
                        hidden
                      />
                      <label htmlFor="donate-amount-4" className="ul-donate-form-label">$40</label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        name="donate-amount"
                        id="donate-amount-5"
                        checked={selectedAmount === 50}
                        onChange={() => { setSelectedAmount(50); setCustomAmount(''); }}
                        hidden
                      />
                      <label htmlFor="donate-amount-5" className="ul-donate-form-label">$50</label>
                    </div>

                    <div className="custom-amount-wrapper">
                      <input
                        type="radio"
                        name="donate-amount"
                        id="donate-amount-custom"
                        checked={selectedAmount === parseFloat(customAmount) && customAmount !== ''}
                        onChange={() => {
                          const num = parseFloat(customAmount);
                          if (!isNaN(num)) setSelectedAmount(num);
                        }}
                        hidden
                      />
                      <label
                        htmlFor="donate-amount-custom"
                        className="ul-donate-form-label"
                      >
                        <input
                          type="number"
                          name="custom-amount"
                          id="donate-amount-custom"
                          placeholder="Custom Amount"
                          className="ul-donate-form-custom-input"
                          value={customAmount}
                          onChange={(e) => {
                            const v = e.target.value;
                            setCustomAmount(v);
                            const num = parseFloat(v);
                            if (!isNaN(num)) setSelectedAmount(num);
                          }}
                        />
                      </label>
                    </div>
                  </div>
                </div>

                    <div className="ul-donation-details-payment-methods">
                  <h3 className="ul-donation-details-payment-methods-title">
                    How Would You Like to Support?
                  </h3>
                  <div className="ul-donation-details-payment-methods-form">
                    <div className="ul-radio">
                      <label htmlFor="method-1">
                        <input
                          type="radio"
                          name="payment-method"
                          id="method-1"
                          checked={paymentMethod === 'one-time'}
                          onChange={() => setPaymentMethod('one-time')}
                        />
                        <span className="checkmark"></span>
                        <span>One-Time Support</span>
                      </label>
                    </div>
                    <div className="ul-radio">
                      <label htmlFor="method-2">
                        <input
                          type="radio"
                          name="payment-method"
                          id="method-2"
                          checked={paymentMethod === 'partner'}
                          onChange={() => setPaymentMethod('partner')}
                        />
                        <span className="checkmark"></span>
                        <span>Partner With Us</span>
                      </label>
                    </div>
                    <div className="ul-radio">
                      <label htmlFor="method-3">
                        <input
                          type="radio"
                          name="payment-method"
                          id="method-3"
                          checked={paymentMethod === 'mentor'}
                          onChange={() => setPaymentMethod('mentor')}
                        />
                        <span className="checkmark"></span>
                        <span>Become a Mentor</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="ul-donation-details-personal-info">
                  <h3 className="ul-donation-details-personal-info-title">
                    Personal Info
                  </h3>
                  <p className="ul-donation-details-personal-info-sub-title">
                    Your email address will not be published. Required fields
                    are marked *
                  </p>
                  <div className="ul-donation-details-personal-info-form">
                    <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                      <div className="col">
                        <div className="form-group">
                          <input
                            type="text"
                            name="first-name"
                            placeholder="First Name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col">
                        <div className="form-group">
                          <input
                            type="text"
                            name="last-name"
                            placeholder="Last Name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ul-donation-details-form-bottom">
                    <button type="submit" className="ul-btn">
                      <i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Support This Campaign
                    </button>
                    <span className="donation-total">Support Amount: <span className="number">${selectedAmount}</span></span>
                  </div>
                </div>
              </form>

              <div className="ul-donation-details-summary">
                <h3 className="ul-donation-details-summary-title">
                  About This Campaign
                </h3>
                <div className="ul-donation-details-summary-txt">
                  <p>
                    Pathio's Diabetes Education campaign creates bilingual
                    (Uzbek/English) health literacy resources that help Central
                    Asian families in NYC understand diabetes prevention,
                    management, and local care options. Our student creators
                    work alongside medical mentors to produce science-based,
                    visually engaging content that breaks down complex health
                    information into simple, actionable guidance.
                  </p>

                  <h4>What We're Creating:</h4>
                  <ul>
                    <li>
                      Bilingual posters and visual explainers (Uzbek/English)
                    </li>
                    <li>TikTok-friendly health literacy videos</li>
                    <li>QR code-enabled clinic resource cards</li>
                    <li>
                      Verified healthcare navigator connections across NYC
                      boroughs
                    </li>
                    <li>
                      Community workshops on diabetes prevention and management
                    </li>
                    <li>Multilingual content in Uzbek, Russian, and Tajik</li>
                    <li>
                      Student mentorship opportunities in public health
                      communication
                    </li>
                    <li>Science-based, clinically reviewed content</li>
                  </ul>

                  <div className="ul-donation-details-summary-imgs">
                    <img
                      src="/assets/new-img/teacher-showing-children-solar-panel-2025-01-29-13-28-03-utc.jpg"
                      alt="Health Literacy Campaign"
                    />
                    <img
                      src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg"
                      alt="Community Workshop"
                    />
                  </div>

                  <p>
                    This campaign directly addresses health literacy gaps in
                    NYC's Central Asian communities. Many families struggle to
                    find healthcare providers who speak their language or
                    understand their cultural context. Our resources bridge that
                    gap by providing clear, accessible information in multiple
                    languages, connecting families to verified clinics, and
                    empowering them to take control of their health.
                  </p>

                  <blockquote>
                    "Pathio's bilingual diabetes explainers helped my family
                    understand what to ask our doctor. The QR codes on the
                    posters led us directly to a clinic that speaks Uzbek. This
                    is exactly what our community needed." — Amina Karimova,
                    Community Member
                  </blockquote>

                  <p>
                    Your support helps us reach more families, create more
                    resources, and expand our mentorship program. Every
                    contribution goes directly toward content creation,
                    community workshops, and connecting families to healthcare
                    resources. Together, we're building a healthier, more
                    informed Central Asian community in NYC.
                  </p>

                  <h4>Impact So Far:</h4>
                  <ul>
                    <li>
                      <strong>2,100+ families reached</strong> with diabetes
                      education materials
                    </li>
                    <li>
                      <strong>162+ verified clinics</strong> connected to
                      community members
                    </li>
                    <li>
                      <strong>12 community workshops</strong> held in Brooklyn
                      and Queens
                    </li>
                    <li>
                      <strong>87+ student mentees</strong> building portfolios
                      in public health communication
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

      <Footer />
    </>
  );
};

export default Donationdetails;
